import React from 'react';
import { Box, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfPlaceholder, colorPalette } from '@qualifio/ui-commons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { useTranslation } from 'react-i18next';
import { ExistingTestUserDetails } from './ExistingTestUserDetails';
import { QlfPlaceholderIcon } from '../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { TestUserCreationDialog } from './TestUserCreationDialog';
import { profilesIcons } from '../shared/icons';
import { useTestUsers } from './TestUsersContext';

function TestUserCreationPopup() {
  const { t } = useTranslation();
  const { creationPopupIsOpen, setCreationPopupIsOpen } = useTestUsers();

  return (
    <Box textAlign="center" pt={3}>
      {!creationPopupIsOpen && (
        <Button
          color="primary"
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => setCreationPopupIsOpen(true)}
          style={{ marginTop: '10px' }}
        >
          {t('test-user.states.empty.create-action')}
        </Button>
      )}

      <TestUserCreationDialog open={creationPopupIsOpen} setOpen={setCreationPopupIsOpen} />
    </Box>
  );
}

export function TestUserDetails(): React.ReactElement {
  const { t } = useTranslation();
  const { selectedTestUser, testUsers, creationPopupIsOpen } = useTestUsers();
  return creationPopupIsOpen ? (
    <TestUserCreationPopup />
  ) : !testUsers?.count || !selectedTestUser ? (
    <QlfPlaceholder
      icon={<QlfPlaceholderIcon icon={profilesIcons} color={colorPalette.grey.main} />}
      primaryText={t('test-user.states.empty.title')}
      secondaryText={t('test-users.states.empty.description')}
      actions={<TestUserCreationPopup />}
    />
  ) : (
    <ExistingTestUserDetails />
  );
}
